import React from 'react';
import { Card, Row, Col, Space, Typography, Divider } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { formatTimeStatus } from '../utils';

const { Text } = Typography;

const ActiveCallCard = ({
    currentCall,
    currentContact,
    status,
    isDialing,
    isInCall,
    selectedCampaign,
    callSeconds
}) => {
    // Solo renderizar si es necesario implica que el padre maneja la visibilidad, pero el componente también puede retornar null
    // La lógica original comprobaba: (isInCall || status === 'wrapup' || status === 'ringing' || isDialing) && (currentCall?.direction === 'inbound' || currentCall?.campaign_id)
    // Asumiremos que el padre pasa estas comprobaciones o las comprobamos dentro. 
    // Vamos a confiar en el padre para "renderizar o no", pero podemos salvaguardar.

    const getStatusColor = () => {
        if (isDialing || status === 'ringing' || (isInCall && status !== 'incall' && status !== 'wrapup')) return '#1890ff';
        if (status === 'incall') return '#cf1322';
        return '#856404';
    };

    const statusText = isDialing || status === 'ringing' || (isInCall && status !== 'incall' && status !== 'wrapup')
        ? 'Timbrando...'
        : (status === 'incall' ? 'Llamada en Curso' : 'Espera de Formulario (Llamada Finalizada)');

    const timerLabel = status === 'incall'
        ? 'Duración: '
        : (isDialing || status === 'ringing' || (isInCall && status !== 'incall' && status !== 'wrapup') ? 'Tiempo de espera: ' : 'Duración final: ');

    const cardStyles = {
        marginBottom: 20,
        marginTop: 20,
        background: status === 'ringing' ? '#e6f4ff' : (status === 'incall' ? '#fff1f0' : '#fffbe6'),
        border: status === 'ringing' ? '1px solid #91caff' : (status === 'incall' ? '1px solid #ffa39e' : '1px solid #ffe58f'),
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
    };

    return (
        <Card
            className="active-call-info-card"
            id="active-call-info-card"
            size="small"
            title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Text strong style={{ color: getStatusColor() }}>
                        {statusText}
                    </Text>
                    <Space style={{ background: 'rgba(255,255,255,0.5)', padding: '2px 10px', borderRadius: '4px' }}>
                        <ClockCircleOutlined />
                        <Text strong style={{ fontSize: '12px' }}>
                            {timerLabel}
                            {formatTimeStatus(callSeconds)}
                        </Text>
                    </Space>
                </div>
            }
            style={cardStyles}
        >
            <Row gutter={24} align="middle">
                <Col span={10}>
                    <Space direction="vertical" size={0}>
                        <Text type="secondary" style={{ fontSize: '11px', textTransform: 'uppercase' }}>Número / Origen</Text>
                        <Text strong style={{ fontSize: '20px', color: status === 'incall' ? '#a8071a' : '#003a8c' }}>
                            {currentCall?.source || currentContact?.phones?.[0] || 'Desconocido'}
                        </Text>
                    </Space>
                </Col>
                <Col span={2}>
                    <Divider type="vertical" style={{ height: '40px', borderColor: status === 'incall' ? '#ffa39e' : '#91d5ff' }} />
                </Col>
                <Col span={12}>
                    <Space direction="vertical" size={0}>
                        <Text type="secondary" style={{ fontSize: '11px', textTransform: 'uppercase' }}>Campaña</Text>
                        <Text strong style={{ fontSize: '18px', color: status === 'incall' ? '#a8071a' : '#003a8c' }}>
                            {selectedCampaign ? selectedCampaign.name : (currentCall && !currentCall.campaign_id ? 'Sin Campaña' : 'Carga de campaña...')}
                        </Text>
                    </Space>
                </Col>
            </Row>
        </Card>
    );
};

export default ActiveCallCard;
